// App.js
import React from 'react';
import { BrowserRouter, HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// Regular Admin components (Pages/Dashboard)
import LandingPage from './Pages/LandingPage/LandingPage';
import PublicLandingPage from './Pages/PublicLandingPage/PublicLandingPage';
import Overview1 from './Pages/Dashboard/Overview1';
import Overview2 from './Pages/Dashboard/Overview2';
import UserManagement from './Pages/Dashboard/UserManagement';
import Settings from './Pages/Dashboard/Settings';
import About from './Pages/Public/AboutPage';
import TermsPage from './Pages/Public/TermsPage';
import PrivacyPage from './Pages/Public/PrivacyPage';
import ScopeLimitationsPage from './Pages/Public/ScopeLimitationsPage';
import DownloadPage from './Pages/Public/DownloadPage';

// System Admin components (Pages/System_AdDashboard)
import SaOverview1 from './Pages/System_AdDashboard/SA_Overview1';
import SaOverview2 from './Pages/System_AdDashboard/SA_Overview2';
import SaUserManagement from './Pages/System_AdDashboard/SA_UserManagement';
import SaSettings from './Pages/System_AdDashboard/SA_Settings';
import SaLogs from './Pages/System_AdDashboard/SA_Logs';
import SaPurchases from './Pages/System_AdDashboard/SA_Purchases';
import SaSecurity from './Pages/System_AdDashboard/SA_Security';
import SaRequests from './Pages/System_AdDashboard/SA_Requests';

import { DocumentUploadProvider } from './context/DocumentUploadContext';
import { DataProvider } from './context/DataContext';
import './App.css';

function App() {
  const isAdminOnlyBuild = process.env.REACT_APP_ADMIN_ONLY === 'true';
  const Router = process.env.REACT_APP_ELECTRON === 'true' ? HashRouter : BrowserRouter;
  const isDashboardSubdomain = window.location.hostname === 'dashboard.avisa.site' || window.location.hostname.startsWith('dashboard.localhost');

  return (
    <Router>
      <AuthProvider>
        <DataProvider>
          <DocumentUploadProvider>
            <ToastContainer
              position="top-right"
              style={{ zIndex: 20000 }}
            />
            <Routes>
              {/* Public routes */}
              {!isAdminOnlyBuild && !isDashboardSubdomain && <Route path="/" element={<PublicLandingPage />} />}
              {/* Dashboard Subdomain root route */}
              {isDashboardSubdomain && <Route path="/" element={<LandingPage />} />}
              
              <Route path="/admin" element={<LandingPage />} />
              
              {/* Regular Admin routes (Pages/Dashboard) */}
              <Route path="/dashboard" element={
                <ProtectedRoute requiredRole="admin">
                  <Overview1 />
                </ProtectedRoute>
              } />
              <Route path="/overview" element={
                <ProtectedRoute requiredRole="admin">
                  <Overview1 />
                </ProtectedRoute>
              } />
              <Route path="/documents" element={
                <ProtectedRoute requiredRole="admin">
                  <Overview2 />
                </ProtectedRoute>
              } />
              <Route path="/user-management" element={
                <ProtectedRoute requiredRole="admin" requiredPermission="manage_users">
                  <UserManagement />
                </ProtectedRoute>
              } />
      
              <Route path="/settings" element={
                <ProtectedRoute requiredRole="admin">
                  <Settings />
                </ProtectedRoute>
              } />
              
              {/* System Admin routes (Pages/System_AdDashboard) */}
              <Route path="/system-admin/dashboard" element={
                <ProtectedRoute requiredRole="system_admin">
                  <SaOverview1 />
                </ProtectedRoute>
              } />
              <Route path="/system-admin/overview" element={
                <ProtectedRoute requiredRole="system_admin">
                  <SaOverview1 />
                </ProtectedRoute>
              } />
              <Route path="/system-admin/documents" element={
                <ProtectedRoute requiredRole="system_admin">
                  <SaOverview2 />
                </ProtectedRoute>
              } />
              <Route path="/system-admin/requests" element={
                <ProtectedRoute requiredRole="system_admin">
                  <SaRequests />
                </ProtectedRoute>
              } />
              <Route path="/system-admin/user-management" element={
                <ProtectedRoute requiredRole="system_admin">
                  <SaUserManagement />
                </ProtectedRoute>
              } />
              <Route path="/system-admin/logs" element={
                <ProtectedRoute requiredRole="system_admin">
                  <SaLogs />
                </ProtectedRoute>
              } />
              <Route path="/system-admin/purchases" element={
                <ProtectedRoute requiredRole="system_admin">
                  <SaPurchases />
                </ProtectedRoute>
              } />
              <Route path="/system-admin/security" element={
                <ProtectedRoute requiredRole="system_admin">
                  <SaSecurity />
                </ProtectedRoute>
              } />
              <Route path="/system-admin/settings" element={
                <ProtectedRoute requiredRole="system_admin">
                  <SaSettings />
                </ProtectedRoute>
              } />
              <Route path="/system-admin/control-center" element={
                <Navigate to="/system-admin/security" replace />
              } />

              {!isAdminOnlyBuild && <Route path="/about" element={<About />} />}
              {!isAdminOnlyBuild && <Route path="/tos" element={<TermsPage />} />}
              {!isAdminOnlyBuild && <Route path="/privacypolicy" element={<PrivacyPage />} />}
              {!isAdminOnlyBuild && <Route path="/scope-and-limitations" element={<ScopeLimitationsPage />} />}
              {!isAdminOnlyBuild && <Route path="/scope" element={<ScopeLimitationsPage />} />}
              {!isAdminOnlyBuild && <Route path="/download" element={<DownloadPage />} />}
              <Route path="*" element={<Navigate to="/admin" replace />} />

            </Routes>
          </DocumentUploadProvider>
        </DataProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
